import React from "react"
import Link from "gatsby-link"
import Helmet from "react-helmet"

import Navigation from '../layouts/navigation.js'
import Footer from '../layouts/footer.js'

import {getJSON_and_pass} from '../components/GlobalFunctions';

import seo_img from '../img/seo/seo-1.svg'

import register_now from '../img/register-now.svg'

import ogp_cover from '../img/cover.png'

class RenderItems extends React.Component {

	constructor(props) {
		super(props);

		this.changePolicy = this.changePolicy.bind(this);

		this.state = {
			privacyId: 1,
			privacyCurrentId: 1,
			privacyText: '',
			privacyVersion: '',
			privacyDateVersion: '',
			privacyEffectiveDate: '',
			privacyPrevious: [],
			privacyLoaded: false,
		};
	}

	formatDate(iso) {
		var date = new Date(iso), year = date.getFullYear(), month = date.getMonth()+1, dt = date.getDate(), newdata = ((month<10)?('0'+month):month)+'/'+((dt<10)?('0'+dt):dt)+'/'+year;
		return newdata;
	}

	changePolicy(e) {
		var self = this;
		self.setState({privacyLoaded: false});
		getJSON_and_pass('GET', '/contractor_profile/api/policies/'+e, null, function(data){
			if (typeof data === 'string') data = JSON.parse(data);
			self.setState({privacyText: data.data.specification});
			self.setState({privacyEffectiveDate: data.data.enabled_date});
			self.setState({privacyCurrentId: e});
			self.setState({privacyLoaded: true});
		}, function(status){});
	}

	componentDidMount() {
		var self = this;
		getJSON_and_pass('GET', '/contractor_profile/api/policies', null, function(data){
			if (typeof data === 'string') data = JSON.parse(data);
			self.setState({privacyId: data.data[0].id});
			self.setState({privacyCurrentId: data.data[0].id});
			self.setState({privacyText: data.data[0].specification});
			self.setState({privacyVersion: data.data[0].version});
			self.setState({privacyDateVersion: data.data[0].enabled_date});
			self.setState({privacyEffectiveDate: data.data[0].enabled_date});
            if(data.data[0].previous) self.setState({privacyPrevious: data.data[0].previous});
			self.setState({privacyLoaded: true});
		}, function(status){});
	}

	renderElement(){
		var self = this;
		if(self.state.privacyPrevious.length>0) 
		return self.state.privacyPrevious.map(function(index) {
			if(self.state.privacyCurrentId !== index.id) {
				return <li key={index.id}>Click here for version <a href={`#privacy-${index.id}`} onClick={(e) => {e.preventDefault(); self.changePolicy(index.id)}} >{index.version}</a> ({self.formatDate(index.enabled_date)})</li>
			} else {
				return <li key={index.id}>This is version {index.version} ({self.formatDate(index.enabled_date)})</li>
			}
		});
		return null;
	}

	render() {
		var self = this;
		if(this.state.privacyLoaded) {
			return (
				<div className="privacy-content">
					<div className="privacy-date">Effective Date: {self.formatDate(self.state.privacyEffectiveDate)}</div>
					<div className="privacy-text" dangerouslySetInnerHTML={{__html:this.state.privacyText}} />
					<h4>Previous Versions</h4>
					<ul className="privacy-versions">
						{(self.state.privacyCurrentId !== self.state.privacyId)?(
							<li>Click here for version <a href={`#privacy-${self.state.privacyId}`} onClick={(e) => {e.preventDefault(); self.changePolicy(self.state.privacyId)}} >{self.state.privacyVersion}</a> ({self.formatDate(self.state.privacyDateVersion)})</li>
						):(
							<li>This is version {self.state.privacyVersion} ({self.formatDate(self.state.privacyDateVersion)})</li>
						)}
						
						{self.renderElement()}

					</ul>
				</div>
			);
		} else {
			return <div className="form-loader"></div>
		}
	}
}

export default class Seo extends React.Component {

	pageClick(e) {
		document.getElementsByTagName('body')[0].className=''
	}

	componentDidMount() {
	    var mask = document.getElementById('mask'), seoText = document.getElementById('seo-text');
	    mask.addEventListener('touchstart', this.pageClick, false);

	}

	render() {
		return (
			<div>

				<Helmet
					title="Privacy Policy | UvoCorp.com"
					meta={[
						{ name: "description", content: "Privacy Policy" },
						{ name: "robots", content: "noindex, follow" },

						{ property: 'og:title', content: "Privacy Policy | UvoCorp.com" },
						{ property: 'og:description', content: "Privacy Policy" },
						{ property: 'og:site_name', content: "UvoCorp.com" },
						{ property: 'og:type', content: "website" },
						{ property: 'og:image', content: ogp_cover },
					]}
					link={[
						{ rel: 'canonical', href: "https://www.uvocorp.com/privacy_policy.html" }
					]} />

				<div className='header' id="header">
					<Navigation />
				</div>

				<div className="wrapper">
				
					<div className="inner-header">
						<div className="container">
							<h1>Privacy Policy</h1>
							<Link to="/register_email.html">Register now</Link>
						</div>
					</div>

					<div className="inner-white hiring seo">
						<div className="container">

							<div className="row seo-row">

								<div className="col-md-4 seo-img-container">
									<div className="seo-img">
										<img src={seo_img} alt="Seo Image"/>
									</div>
								</div>
								<div className="col-md-8">
									<div className="seo-text">
										<RenderItems />
									</div>
								</div>
							</div>

						</div>
					</div>

					<div className="inner-registration">
						<div className="container">
							<div className="inner-registration-image">
								<div className="img inner-registration-img">
									<img src={register_now} alt="Start registration"/>
								</div>
							</div>
							<div className="inner-registration-text">
								<div className="inner-registration-title">Register now <br />to start earning!</div>
								<div className="inner-registration-button">
									<Link to="/register_email.html">Start registration</Link>
								</div>
							</div>
						</div>
					</div>

					<Footer />

				</div>
				<div id="mask" className="c-mask"></div>

			</div>
		)
	}
}



// WEBPACK FOOTER //
// ./src/pages/privacy_policy.html.js